module.exports = __webpack_public_path__ + "static/media/bursh.7b698ac7.svg";